import * as Sentry from '@sentry/react-native';
import { Platform } from 'react-native';
import appsFlyer from 'react-native-appsflyer';

import { APPSFLYER_CONFIG } from '@/constants/config';

import { firebaseImage } from './firebaseImage';

const createShortDeepLinkMobile = async (
  route: string,
  thumb?: string,
  afTitle?: string,
  afDescription?: string
): Promise<string | undefined> => {
  return new Promise((resolve: (value: string | undefined) => any) => {
    //ToDO: Change default description if needed
    const metaDataImage = thumb === undefined || thumb.length === 0 ? firebaseImage('deeplink_thumbnail.png') : thumb;

    appsFlyer.generateInviteLink(
      {
        channel: 'User_invite',
        campaign: APPSFLYER_CONFIG.c,
        brandDomain: APPSFLYER_CONFIG.brandDomain,
        userParams: {
          af_og_title: afTitle ?? APPSFLYER_CONFIG.af_og_title,
          af_dp: APPSFLYER_CONFIG.af_dp,
          af_web_dp: APPSFLYER_CONFIG.af_web_dp,
          brandDomain: APPSFLYER_CONFIG.brandDomain,
          af_force_deeplink: true,
          deep_link_value: route,
          af_og_description:
            afDescription ??
            'Start exploring Broken Shepherds™ and begin your journey today. Discover engaging content and new experiences tailored just for you.',
          af_og_image: encodeURI(metaDataImage)
        }
      },
      (link) => {
        resolve(link as string);
      },
      (e) => {
        console.error(e);
        Sentry.captureException(e);
        resolve(undefined);
      }
    );
  });
};

const createShortDeepLinkWeb = async (
  route: string,
  thumb?: string,
  afTitle?: string,
  afDescription?: string
): Promise<string | undefined> => {
  return new Promise((resolve: (value: string | undefined) => any) => {
    //ToDO: Change default description if needed
    const baseOneLink = `https://${APPSFLYER_CONFIG.brandDomain}/${
      process.env.EXPO_PUBLIC_APPFLYER_ONE_LINK_TEMPLATE_ID ?? '-'
    }`;

    const metaDataImage = thumb === undefined || thumb.length === 0 ? firebaseImage('deeplink_thumbnail.png') : thumb;

    const queryString = new URLSearchParams({
      c: APPSFLYER_CONFIG.c,
      pid: 'User_invite',
      deep_link_value: route,
      af_og_title: afTitle ?? APPSFLYER_CONFIG.af_og_title,
      af_dp: APPSFLYER_CONFIG.af_dp,
      af_web_dp: APPSFLYER_CONFIG.af_web_dp,
      af_force_deeplink: `true`,
      brandDomain: APPSFLYER_CONFIG.brandDomain,
      af_og_description:
        afDescription ??
        `Start exploring Broken Shepherds™ and begin your journey today. Discover engaging content and new experiences tailored just for you.`,
      af_og_image: metaDataImage
    }).toString();

    resolve(`${baseOneLink}?${queryString}`);
  });
};

export const createShortDeepLinkApiBody = async (
  route: string,
  thumb?: string,
  afTitle?: string,
  afDescription?: string
): Promise<string | undefined> => {
  const oneLinkId = process.env.EXPO_PUBLIC_APPFLYER_ONE_LINK_TEMPLATE_ID;

  if (!oneLinkId) {
    console.error('AppsFlyer OneLink ID is missing');
    return undefined;
  }

  const metaDataImage = thumb === undefined || thumb.length === 0 ? firebaseImage('deeplink_thumbnail.png') : thumb;

  try {
    const isCustomDomain = !APPSFLYER_CONFIG.brandDomain.includes('onelink.me');

    return JSON.stringify({
      ...(isCustomDomain && { brand_domain: APPSFLYER_CONFIG.brandDomain }),
      data: {
        pid: 'User_invite',
        c: APPSFLYER_CONFIG.c,
        af_channel: 'User_invite',
        deep_link_value: route,
        af_og_title: afTitle ?? APPSFLYER_CONFIG.af_og_title,
        af_og_description:
          afDescription ??
          'Start exploring Broken Shepherds™ and begin your journey today. Discover engaging content and new experiences tailored just for you.',
        af_og_image: metaDataImage,
        af_dp: APPSFLYER_CONFIG.af_dp,
        af_web_dp: APPSFLYER_CONFIG.af_web_dp,
        af_force_deeplink: 'true'
      }
    });
  } catch (error) {
    console.error('Error creating AppsFlyer body', error);
    Sentry.captureException(error);
    return undefined;
  }
};

export const createShortDeepLink = async (
  route: string,
  thumb?: string,
  afTitle?: string,
  afDescription?: string
): Promise<string | undefined> => {
  if (Platform.OS === 'web') {
    return createShortDeepLinkWeb(route, thumb, afTitle, afDescription);
  }
  return createShortDeepLinkMobile(route, thumb, afTitle, afDescription);
};
